import { Box, Link, Stack, Typography } from '@mui/material';
import { openExternal } from 'utils/openExternal';
import { TrackCover } from './TrackCover';

export interface TrackEntryProps {
  title: string;
  artist?: string;
  cover?: string;
  action?: React.ReactNode;
  titleUrl?: string;
  artistUrl?: string;
}

export function TrackEntry(props: TrackEntryProps) {
  return (
    <Stack direction="row" sx={{ width: '100%', p: 1 }}>
      <Box
        sx={{
          width: 48,
          height: 48,
          objectFit: 'cover',
          overflow: 'hidden',
          flexShrink: 0,
          borderRadius: 2,
          '& > img': {
            width: '100%',
          },
        }}
      >
        <TrackCover title={props.title} cover={props.cover} />
      </Box>
      <Stack sx={{ minWidth: 0, justifyContent: 'center', px: 1 }}>
        {props.title &&
          (props.titleUrl ? (
            <Link
              href={props.titleUrl || ''}
              noWrap
              underline="hover"
              sx={{
                lineHeight: 1.25,
                fontWeight: 'bold',
                color: 'inherit',
              }}
              onClick={(event) => {
                event.preventDefault();
                openExternal(props.titleUrl!);
              }}
            >
              {props.title}
            </Link>
          ) : (
            <Typography noWrap sx={{ lineHeight: 1.25, fontWeight: 'bold' }}>
              {props.title}
            </Typography>
          ))}
        {props.artist &&
          (props.artistUrl ? (
            <Link
              href={props.artistUrl || ''}
              noWrap
              variant="caption"
              underline="hover"
              sx={{
                display: 'block',
                lineHeight: 1.25,
                color: 'inherit',
              }}
              onClick={(event) => {
                event.preventDefault();
                openExternal(props.artistUrl!);
              }}
            >
              {props.artist}
            </Link>
          ) : (
            <Typography noWrap variant="caption" sx={{ display: 'block', lineHeight: 1.25 }}>
              {props.artist}
            </Typography>
          ))}
      </Stack>
      <Box sx={{ display: 'flex', alignItems: 'center', ml: 'auto' }}>{props.action}</Box>
    </Stack>
  );
}
